import { render, staticRenderFns } from "./barChart.vue?vue&type=template&id=12cfd58a&scoped=true&"
import script from "./barChart.vue?vue&type=script&lang=js&"
export * from "./barChart.vue?vue&type=script&lang=js&"
import style0 from "./barChart.vue?vue&type=style&index=0&id=12cfd58a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cfd58a",
  null
  
)

export default component.exports